module.exports = __webpack_public_path__ + "static/media/manipulator-trajectory.ecd429fe.gif";